import { Alert } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import { controlRegistry, fieldRegistry } from '../../fields/fieldRegistry'
import { getAtPath } from '../../utils/configPaths'
import { matchesCondition, visibleOptions } from '../../utils/conditions'
import { sliderElementLimitReached } from '../../utils/sliderValidation'

// Packages can declare only components registered by the trusted editor.

export function FieldRenderer({
  field,
  templateManifest,
  configuration,
  basePath = '',
  item = null,
  error,
  onChange,
  addAsset,
  addRenditionPreview,
  assetUrls,
  assetSourceUrls,
}) {
  const { t } = useTranslation()
  if (!matchesCondition(field.visibleWhen, configuration, item)) return null

  // `ui.control` only swaps the rendering; the field keeps its declared type for
  // validation and for the preview runtime. An unrecognised control degrades to the
  // type's default component rather than erroring.
  const control = field.ui && field.ui.control
  const Component = (control && controlRegistry[control]) || fieldRegistry[field.type]
  if (!Component) {
    return <Alert color="red">{t('editorV2.form.fields.unsupported', { type: field.type })}</Alert>
  }

  const path = basePath ? `${basePath}.${field.path}` : field.path
  const value = basePath
    ? getAtPath(configuration, path)
    : getAtPath(configuration, field.path)

  return (
    <Component
      field={field}
      disabled={sliderElementLimitReached(configuration, path)}
      templateManifest={templateManifest}
      // The rendered path, not the declared one: inside a collection it carries
      // the item's index, which is how a field finds the alternatives written
      // for its own slide.
      path={path}
      value={value}
      error={error}
      options={visibleOptions(field.options, configuration, item)}
      configuration={configuration}
      item={item}
      addAsset={addAsset}
      addRenditionPreview={addRenditionPreview}
      assetUrls={assetUrls}
      assetSourceUrls={assetSourceUrls}
      onChange={(nextValue) => onChange(path, nextValue)}
    />
  )
}
